import React from "react";
import { FormSelectOption } from "@patternfly/react-core";

export default function arrayToFormSelectOptions(array) {
  if (array[0].name !== "Please Choose...") {
    array.unshift({ name: "Please Choose...", isDisabled: false });
  }

  return array.map((option, index) => (
    <FormSelectOption
      isDisabled={option.disabled}
      key={`option-${index}`}
      value={option.name}
      label={option.name}
    />
  ));
}
